import React, { useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "./Home";
import NewReferral from "./pages/NewReferral";
import ReferList from "./pages/ReferList";
import LoginPage from "./Login";
import { getSavedUser, clearAuth } from "./lib/globalfunction";

function App() {
  const bypassLogin = process.env.REACT_APP_BYPASS_LOGIN === "true";
  const [user, setUser] = useState(() => {
    const saved = getSavedUser();
    if (saved) return saved;
    if (bypassLogin) {
      const dummy = { id: "demo", loginname: "demo", name: "Demo User", role: "user" };
      try {
        localStorage.setItem("userinfo", JSON.stringify(dummy));
      } catch (e) {}
      return dummy;
    }
    return null;
  });

  const handleLogout = () => {
    clearAuth();
    setUser(null);
  };

  const handleLogin = (u) => {
    setUser(u);
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage onLogin={handleLogin} />} />
        <Route
          path="/home"
          element={
            user ? (
              <Home user={user} onLogout={handleLogout} />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        <Route
          path="/newreferral"
          element={user ? <NewReferral /> : <Navigate to="/login" replace />}
        />
        <Route
          path="/referlist"
          element={user ? <ReferList /> : <Navigate to="/login" replace />}
        />

        <Route
          path="/"
          element={
            user ? (
              <Navigate to="/home" replace />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
